import { FaqProps } from "@ft/components/common/Faq";

const RandomStringGeneratorFaq: FaqProps[] = [
  {
    question: "What is the definition of a Random String Generator?",
    ans: `
    This is a free online tool to create random strings based on the options you choose.`,
  },
  {
    question: "Is it secure?",
    ans: `Yes, our tool is 100% safe and secure Random String Generator. It does not store or share any of your data or the generated strings.`,
  },
  {
    question: "Can I generate multiple strings at once?",
    ans: "Yes, you can specify how many strings you want to generate at once.",
  },
  {
    question: "Can I control the case sensitivity?",
    ans: "Yes, you can choose the format of string in all lowercase, all uppercase, or mixed-case, and more.",
  },
  {
    question: "How do I set the string length? ",
    ans: "By using the String length option you can generate it according to your requirement.",
  },
  {
    question: "Is it safe to use these strings for passwords?",
    ans: "Yes, you can generate the best password by choosing a lengthy string with mixed cases and symbols.",
  },
  {
    question: "Does your tool store any of the generated strings?",
    ans: "No, the strings are generated and displayed directly on your browser only. Our servers do not store your information",
  },
  {
    question: "Can I export the generated strings?",
    ans: "Yes, you can download the generated strings as a text file or copy them to your clipboard.",
  },
];

export default RandomStringGeneratorFaq;
